<div class="inner-block animate">
  <div class="row">
    <div class="block full-width">
      <div class="col-12">
        <h2>Redigera apparat</h2>
        <div class="account__card">
          <dot-loader [visibility]="loading()" [large]="true"></dot-loader>
          @if(!loading()) {
            <form (submit)="updateDeviceGroup()">
              <h3>Instream estimat</h3>
  
              <div class="form-group input__container">
                <label for="name">Namn *</label>
                <input 
                  id="name" 
                  name="name" 
                  [(ngModel)]="devices().name" 
                  required 
                  class="form-control"
                >
              </div>
              <div class="form-group input__container">
                <label for="description">Beskrivning *</label>
                <input 
                  id="description" 
                  name="description" 
                  [(ngModel)]="devices().description" 
                  required 
                  class="form-control"
                >
              </div>
  
              <table class="table table-hover table-woo table--info width--100">
                <thead>
                  <tr>
                    <th [colSpan]="staticFields"></th>
                    <th class="text--thin text--small capitalize--first-letter centered" colspan="2"></th>
                    <th class="text--thin text--small capitalize--first-letter centered" colspan="3">
                      Estimatfördelning
                    </th>
                    <th class="text--thin text--small capitalize--first-letter centered" colspan="3">
                      Maxuttag
                    </th>
                  </tr>
                  <tr>
                    @for(header of tableHeaders; track $index) {
                      <th  class="text--thin text--small capitalize--first-letter">
                        {{header}}
                      </th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @if(updating()) {
                    <tr>
                      <td colspan="8" class="text--thin vertical-align--middle align-middle table-header-padding centered">
                        <dot-loader [visibility]="updating()" [large]="true"></dot-loader>
                      </td>
                    </tr>
                  } @else {
                    @for(row of inRows(); track $index; let index = $index;) {
                      <tr>
                        <td class="text--thin vertical-align--middle align-middle table-header-padding">
                          <span>{{translateProductFormat(row.productFormat)}}</span>
                        </td>
                        <td class="text--thin vertical-align--middle align-middle table-header-padding">
                          <span>{{row.publisher}}</span>
                        </td>
                        <td class="vertical-align--middle">
                          <div class="form-group input__container">
                            <input
                              name="row-{{index}}-sharesPreroll"
                              [(ngModel)]="devices().shares[row.publisherId][row.productFormatId].preroll"
                              wooPercentFormatter
                              [wooMinValidator]="0"
                              [wooMaxValidator]="1"
                              [required]="includedProductFormatSlotTypesSig()[row.productFormatId].preroll"
                              [disabled]="!includedProductFormatSlotTypesSig()[row.productFormatId].preroll"
                              class="form-control"
                            >
                          </div>
                        </td>
                        <td class="vertical-align--middle">
                          <div class="form-group input__container">
                            <input
                              name="row-{{index}}-sharesMidroll"
                              [(ngModel)]="devices().shares[row.publisherId][row.productFormatId].midroll"
                              wooPercentFormatter
                              [wooMinValidator]="0"
                              [wooMaxValidator]="1"
                              [required]="includedProductFormatSlotTypesSig()[row.productFormatId].midroll"
                              [disabled]="!includedProductFormatSlotTypesSig()[row.productFormatId].midroll"
                              class="form-control"
                            >
                          </div>
                        </td>
                        <td class="vertical-align--middle">
                          <div class="form-group input__container">
                            <input
                              name="row-{{index}}-sharesPostroll"
                              [(ngModel)]="devices().shares[row.publisherId][row.productFormatId].postroll"
                              wooPercentFormatter
                              [wooMinValidator]="0"
                              [wooMaxValidator]="1"
                              [required]="includedProductFormatSlotTypesSig()[row.productFormatId].postroll"
                              [disabled]="!includedProductFormatSlotTypesSig()[row.productFormatId].postroll"
                              class="form-control"
                            >
                          </div>
                        </td>
                        <td class="vertical-align--middle">
                          <div class="form-group input__container">
                            <input
                              name="row-{{index}}-withdrawalLimitsPreroll"
                              [(ngModel)]="devices().withdrawal_limits[row.publisherId][row.productFormatId].preroll"
                              wooPercentFormatter
                              [wooMinValidator]="0"
                              [wooMaxValidator]="1"
                              [required]="includedProductFormatSlotTypesSig()[row.productFormatId].preroll"
                              [disabled]="!includedProductFormatSlotTypesSig()[row.productFormatId].preroll"
                              class="form-control"
                            >
                          </div>
                        </td>
                        <td class="vertical-align--middle">
                          <div class="form-group input__container">
                            <input
                              name="row-{{index}}-withdrawalLimitsMidroll"
                              [(ngModel)]="devices().withdrawal_limits[row.publisherId][row.productFormatId].midroll"
                              wooPercentFormatter
                              [wooMinValidator]="0"
                              [wooMaxValidator]="1"
                              [required]="includedProductFormatSlotTypesSig()[row.productFormatId].midroll"
                              [disabled]="!includedProductFormatSlotTypesSig()[row.productFormatId].midroll"
                              class="form-control"
                            >
                          </div>
                        </td>
                        <td class="vertical-align--middle">
                          <div class="form-group input__container">
                            <input
                              name="row-{{index}}-withdrawalLimitsPostroll"
                              [(ngModel)]="devices().withdrawal_limits[row.publisherId][row.productFormatId].postroll"
                              wooPercentFormatter
                              [wooMinValidator]="0"
                              [wooMaxValidator]="1"
                              [required]="includedProductFormatSlotTypesSig()[row.productFormatId].postroll"
                              [disabled]="!includedProductFormatSlotTypesSig()[row.productFormatId].postroll"
                              class="form-control"
                            >
                          </div>
                        </td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
  
              <h3>Outstream estimat</h3>
              <outstream-estimates-input
                [sites]="sites()"
                [(shares)]="devices().outstream_shares"
                [(withdrawalLimits)]="devices().outstream_withdrawal_limits"
              ></outstream-estimates-input>
  
              <div class="margin-top--2x">
                <button 
                  type="submit"
                  class="button primary-1"
                  [disabled]="updating()"
                >
                  Spara
                </button>
                <button 
                  type="button"
                  class="link primary-1"
                  [routerLink]="['/products']"
                  [queryParams]="{ tab: 'apparater' }"
                >
                  Avbryt
                </button>
              </div>
            </form>
          }
        </div>
      </div>
    </div>
  </div>
</div>
